import {flashy} from "./src/utils/toastFunctions";

$(function () {
    //Validate teh DI form on load
    validate_di_form();
    
    //Vlidaate DI form on form closing
    $('#ats_di_form_container').on('hidden.bs.collapse', function(){
        validate_di_form();
    });
    
    //Force remove the has-error tag on DI form opening
    $('#ats_di_form_container').on('show.bs.collapse', function(){
        $('.ats_di_container').removeClass('has-error');
    });
    
    $('.manual-apply-button').on('click', function(){
        if($('.ats_di_container').hasClass('has-error')){
            flashy('Error','Please fill in the diversity & inclusion questionnaire', 'e');
        }
    });
});



/**
 * Function used to validate DI form additionally to the adapt framework
 * This is required because the adapt framework does not validate hidden inputs/select
 */
function validate_di_form()
{
    $('.ats_di_container').removeClass('has-error'); //<=== Remove the has-error class from container whenver the DI form is open/closed
    if($('.di_dropdown_question:visible').length === 0)
    {
        //Looping around every question when the DI form is closed
        let DIquestions = $('.di_dropdown_question');
        $.each(DIquestions, function(index, item){
            if($(item).val() === undefined || $(item).val() === "-1" || $(item).val() === null)
            {
                $('.ats_di_container').addClass('has-error'); //<=== If any question has an invalid value append the has-error class to the main container so the submit cant pass
            }
        });
    }
}